import CookiesEnum from "@/core/constants/cookiesEnum";

export const setCookie = (name, value, expires = 400) => {
    if (!cookies2IsActive()) {
        return false;
    }

    Cookies2.set(name, value, {expires});
    return true;
}

export const getCookie = (name) => {
    if (!cookies2IsActive()) {
        return null;
    }
    return Cookies2.get(name);
}

export const getJsonCookie = (name) => {
    const stringValue = getCookie(name);

    try {
        return JSON.parse(stringValue)
    } catch (e) {
        return null;
    }
}

export const setJsonCookie = (name, jsonValue, expires = 400) => {
    try {
        const stringValue = JSON.stringify(jsonValue)
        setCookie(name, stringValue, expires)

        return true;
    } catch (e) {
        return false;
    }
}

export const removeCookie = (name) => {
    if (!cookies2IsActive()) {
        return null;
    }

    return Cookies2.remove(name);
}

export function incrementNativeAdImpressionCount() {
    const currentCount = parseInt(getCookie(CookiesEnum.NATIVE_ADVERT_IMPRESSION_COUNT) || '0', 10);
    const newCount = currentCount + 1;
    setCookie(CookiesEnum.NATIVE_ADVERT_IMPRESSION_COUNT, newCount.toString(), 365);

    return newCount;
}

function cookies2IsActive() {
    if (typeof window === "undefined") {
        return false;
    }

    return !!Cookies2;
}
